<template>
  <i v-if="diff > 0" class="pi pi-arrow-up" style="color: red"></i>
  <i v-if="diff < 0" class="pi pi-arrow-down" style="color: green"></i>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "DmeArrow",
  props: {
    diff: {
      type: Number,
      default: 0,
    },
  },
});
</script>

<style></style>
